import { _t } from "core/language";
import {
  useCommunityFollowMain,
  useCommunityTrendMain,
  useCommunityVideoMain,
} from "modules/Main/hooks";
import { memo } from "react";
import MainNodata from "../NodataComponent";
import CommunityHeader from "./CommunityHeader";
import ItemCommunity from "./ItemCommunity";
import { Button } from "core/components/form-controls";
import PlusIcon from "../../components/icon/plus.svg";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { RouterName } from "core/router";
const CommunityLineSection = () => {
  const navigate = useCustomNavigate();
  const [dataTrend, loadingTrend] = useCommunityTrendMain({
    tab: "trending",
  });
  const [dataFollow, loadingFollow] = useCommunityFollowMain({
    tab: "follow",
  });
  const [dataVideo, loadingVideo] = useCommunityVideoMain({
    tab: "video",
  });

  return (
    <section className={`relative py-4 w-full bg-white`}>
      <CommunityHeader />
      <div className="mt-3">
        <h2 className="px-4 text-[16px] font-semibold text-[#111111]">
          {_t("main.community.trending")}
        </h2>
        <div className="flex flex-col items-start overflow-x-scroll no-scrollbar">
          <div className="flex mt-3.5 gap-2 px-4">
            {(dataTrend || []).map((community: any, index: any) => (
              <div key={index} className="flex flex-col items-start">
                <div className="w-[140px]">
                  <ItemCommunity community={community} key={index} tab='trending' />
                </div>
              </div>
            ))}
          </div>
        </div>
        <MainNodata
          loading={loadingTrend}
          data={dataTrend}
          text={_t("main.community.no_data")}
        />
      </div>

      <div>
        <h2 className="px-4 text-[16px] font-semibold text-[#111111] mt-3">
          {_t("main.community.follow")}
        </h2>
        <div className="flex flex-col items-start overflow-x-scroll no-scrollbar">
          <div className="flex mt-3.5 gap-2 px-4">
            {(dataFollow || []).map((community: any, index: any) => (
              <div key={index} className="flex flex-col items-start">
                <div className="w-[140px]">
                  <ItemCommunity community={community} key={index} tab='follow' />
                </div>
              </div>
            ))}
          </div>
        </div>
        <MainNodata
          loading={loadingFollow}
          data={dataFollow}
          text={_t("main.community.no_data")}
        />
      </div>

      <div>
        <h2 className="px-4 text-[16px] font-semibold text-[#111111] mt-3">
          {_t("main.community.video")}
        </h2>
        <div className="flex flex-col items-start overflow-x-scroll no-scrollbar">
          <div className="flex mt-3.5 gap-2 px-4">
            {(dataVideo || []).map((community: any, index: any) => (
              <div key={index} className="flex flex-col items-start">
                <div className="w-[140px]">
                  <ItemCommunity community={community} key={index} tab='video' />
                </div>
              </div>
            ))}
          </div>
        </div>
        <MainNodata
          loading={loadingVideo}
          data={dataVideo}
          text={_t("main.community.no_data")}
        />
      </div>
      <div className="flex justify-center">
        <Button
          label={_t("main.community.discover_post")}
          classBtn="mt-6 !w-[calc(100%-30px)] font-medium"
          // icon={<i className="fas fa-chevron-down"></i>}
          iconRight={PlusIcon}
          onClickBtn={() => navigate(RouterName.COMMUNITY_LIST)}
        ></Button>
      </div>
    </section>
  );
};

export default memo(CommunityLineSection);
